import { FunctionComponent, createContext, useContext, useEffect, useState } from 'react';
import { noop } from 'lodash';
import { useJourneyAssist } from '../hooks';
import { PromptType } from '../components/JourneyAssist/JourneyAssist.constants';

type JourneyAssistContextState = {
  promptType?: PromptType;
  shouldShowJourneyAssist: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  addToPathTileId?: string;
  sourceEdges?: any[];
  targetEdges?: any[];
  onHighlightDialog?: () => void;
  shouldShowHighlight?: boolean;
  isJourneyAssistActive?: boolean;
  setIsJourneyAssistActive: (isJourneyAssistActive: boolean) => void;
};

const JourneyAssistContext = createContext<JourneyAssistContextState>({
  promptType: undefined,
  shouldShowJourneyAssist: false,
  isOpen: false,
  setIsOpen: noop,
  addToPathTileId: '',
  sourceEdges: [],
  targetEdges: [],
  onHighlightDialog: noop,
  isJourneyAssistActive: false,
  setIsJourneyAssistActive: noop,
});

export const JourneyAssistContextProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [shouldShowHighlight, setHighlightIsShown] = useState(false);
  const [isJourneyAssistActive, setIsJourneyAssistActive] = useState(false);

  const journeyAssist = useJourneyAssist();
  const { promptType } = journeyAssist;

  useEffect(() => {
    if (!promptType) setIsOpen(false);
  }, [promptType]);

  const handleHighlightDialog = () => {
    if (!shouldShowHighlight) {
      setHighlightIsShown(true);

      setTimeout(() => {
        setHighlightIsShown(false);
      }, 1000);
    }
  };

  const context: JourneyAssistContextState = {
    isOpen,
    setIsOpen,
    onHighlightDialog: handleHighlightDialog,
    shouldShowHighlight,
    isJourneyAssistActive,
    setIsJourneyAssistActive,
    ...journeyAssist,
  };
  return <JourneyAssistContext.Provider value={context}>{children}</JourneyAssistContext.Provider>;
};

export const useJourneyAssistContext = () => useContext(JourneyAssistContext);
